import * as types from './mutation-types'
import * as globalTypes from '../../mutation-types'
import restrictionsAPI from '../../../api/restrictions.js'

export const getAllRestrictions = ({commit}) => {
	restrictionsAPI.getAll()
		.then((response) => {
	      if (response.data.status === "Success") {
	        commit(types.RESTRICTIONS_GET_ALL, response.data.data)
	      }
	      else {
	        //show Error
	         var error = {
	            title: 'Error',
	            message: 'ERROR',
	            type: 'error'
	        }
	        commit(globalTypes.NOTIFY_ERRORS, error)
	      }
		})
}

export const setSelectedRestriction = ({ commit }, restriction) => {
  commit(types.SET_SELECTED_RESTRICTION, restriction)
};

export const updateRestriction = ({ commit }, r) => {
		return restrictionsAPI.update(r)
			.then((response) => {
		      if (response.data.status === "Success") {

		      }
		      else {
		        //show Error
		         let error = {
		            title: 'Error',
		            message: (response.data.data[0] || response.data.data).message,
		            type: 'error'
		        }
		        commit(globalTypes.NOTIFY_ERRORS, error)
		      }
          return response
		})
}

export const createRestriction = ({ commit }, restriction) => {
  return restrictionsAPI.create(restriction)
			.then((response) => {
		      if (response.data.status === "Success") {

		      }
		      else {
		        //show Error
		         var error = {
		            title: 'Error',
		            message: response.data.data[0].message,
		            type: 'error'
		        }
		        commit(globalTypes.NOTIFY_ERRORS, error)
		      }
          return response
			})
}

export const deleteRestriction = ({ commit }, id) => {
  return restrictionsAPI.delete(id)
    .then(result => {
      if(result.data.status === "Success"){
        commit(types.DELETE_RESTRICTION, id)
      }
      else {
        let error = {
          title: 'Error',
          message: (result.data.data[0] || result.data.data).message,
          type: 'error'
        }
        commit(globalTypes.NOTIFY_ERRORS, error)
      }
      return result
    })
}




// WEBPACK FOOTER //
// ./src/store/modules/restrictions/actions.js